import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Items18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M4.5 5.25H13.5V3.75H4.5V5.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.5 8.25C16.1904 8.25 16.75 7.69036 16.75 7V2C16.75 1.30964 16.1904 0.75 15.5 0.75H2.5C1.80964 0.75 1.25 1.30964 1.25 2V7C1.25 7.69036 1.80964 8.25 2.5 8.25H15.5ZM15.25 2.25V6.75H2.75V2.25H15.25Z'
      fill='currentColor'
    />
    <path
      d='M5 14.5C5.55228 14.5 6 14.0523 6 13.5C6 12.9477 5.55228 12.5 5 12.5C4.44772 12.5 4 12.9477 4 13.5C4 14.0523 4.44772 14.5 5 14.5Z'
      fill='currentColor'
    />
    <path
      d='M10 13.5C10 14.0523 9.55228 14.5 9 14.5C8.44772 14.5 8 14.0523 8 13.5C8 12.9477 8.44772 12.5 9 12.5C9.55228 12.5 10 12.9477 10 13.5Z'
      fill='currentColor'
    />
    <path
      d='M13 14.5C13.5523 14.5 14 14.0523 14 13.5C14 12.9477 13.5523 12.5 13 12.5C12.4477 12.5 12 12.9477 12 13.5C12 14.0523 12.4477 14.5 13 14.5Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.5 17.25C16.1904 17.25 16.75 16.6904 16.75 16V11C16.75 10.3096 16.1904 9.75 15.5 9.75H2.5C1.80964 9.75 1.25 10.3096 1.25 11V16C1.25 16.6904 1.80964 17.25 2.5 17.25H15.5ZM15.25 11.25V15.75H2.75V11.25H15.25Z'
      fill='currentColor'
    />
  </Svg>
);

Items18.displayName = 'Items18';
export default Items18;
